import React from "react";
import { Navigate } from "react-router-dom";

import { useGetConfigParameter } from "hooks";
import { isFeatureEnabled } from "utils";
import { Loading } from "components";

import { FeatureFlagRouteProps } from "./types";

export const FeatureFlagRoute: React.FC<FeatureFlagRouteProps> = ({
  featureFlag,
  redirectTo,
  children,
}) => {
  const { data: configParameter, isLoading } = useGetConfigParameter();

  if (isLoading) return <Loading />;

  if (!isFeatureEnabled(configParameter, featureFlag)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
